<div class="row answers">
    <form [formGroup]="form">
        <div class="col l6 m12 s12" *ngFor="let answer of feedbackAnswers; let i = index">
            <mat-form-field>
                <textarea matInput cdkTextareaAutosize formControlName="remark" [(ngModel)]='remark' placeholder="{{ 'YourRemark'|translate }}" [value]="remark"></textarea>
            </mat-form-field>

            <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="20px" class="mt-20">
                <div fxFlex="50">
                    <button mat-stroked-button color="accent" (click)="answerChanged(answer, true, remark); nextQuestionClicked(true); feedbackQuestionService.backClicked.emit(question)" [disabled]="!hasAnsweredQuestion">
                        <mat-icon>arrow_back</mat-icon>&nbsp;{{ 'Back' | translate }}
                    </button>
                </div>

                <div fxFlex="50">
                    <button mat-raised-button color="accent" (click)="answerChanged(answer, true, remark); nextQuestionClicked()" [disabled]="isSubmitting">{{ 'Save'|translate }} <mat-icon>arrow_forward</mat-icon></button>
                </div>
            </div>
        </div>
    </form>
</div>
